"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stage = exports.Language = exports.Segment = void 0;
var Segment;
(function (Segment) {
    Segment["Fixter_UK"] = "FIXTER-UK";
    Segment["Fixter_FR"] = "FIXTER-FR";
    Segment["Motrio_FR"] = "MOTRIO-FR";
})(Segment = exports.Segment || (exports.Segment = {}));
var Language;
(function (Language) {
    Language["ENGLISH"] = "english";
    Language["FRENCH"] = "french";
})(Language = exports.Language || (exports.Language = {}));
var Stage;
(function (Stage) {
    Stage["DEVELOPMENT"] = "dev";
    Stage["STAGING"] = "staging";
    Stage["PRODUCTION"] = "production";
})(Stage = exports.Stage || (exports.Stage = {}));
//# sourceMappingURL=constants.js.map